import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Page,
  Aggregate,
  AggregateColumnsDirective,
  AggregateColumnDirective,
  AggregateDirective,
  AggregatesDirective,
  Edit,
  Toolbar,
  Group,
  Sort,
  Inject,
  FilterSettingsModel,
  Filter,
  ExcelExport,
  ExcelQueryCellInfoEventArgs,
  Reorder,
  Resize,
  // PdfQueryCellInfoEventArgs,
} from "@syncfusion/ej2-react-grids";
import { DialogComponent } from "@syncfusion/ej2-react-popups";
import { ClickEventArgs } from "@syncfusion/ej2-navigations";
import { useRef } from "react";
import { WCSType } from "../../../../db/model";
import ErrorBoundary from "../../../../ErrorBoundary";

let refresh: Boolean;

function WcsComponent({ wcsData }: { wcsData: WCSType[] }) {
  const gridInstance = useRef<GridComponent>(null);
  const alertDialogInstance = useRef<DialogComponent>(null);

  const filterSettings: FilterSettingsModel = { type: "Excel" };
  const toolbarOptions: any = ["ExcelExport"];
  const editSettings: any = { allowEditing: false };
  // const editparams: any = { params: { popupHeight: "300px" } };
  // const partyNameRule: Object = { required: true };
  // const orderNoRules: Object = { required: true };
  const dateFormat: any = { type: "date", format: "dd-MMM-yyyy" };

  // const groupOptions: Object = { showGroupedColumn: false, columns: ["rate"] };
  const groupOptions: Object = { showGroupedColumn: false, columns: [] };
  const visible = false;
  const animationSettings: Object = { effect: "None" };
  const alertButtons = [
    {
      click: () => {
        alertDialogInstance.current?.hide();
      },
      buttonModel: { content: "OK", isPrimary: true },
    },
  ];

  function dataBound() {
    if (refresh) {
      gridInstance.current?.groupColumn("rate");

      refresh = false;
    }
  }

  function exportQueryCellInfo(args: ExcelQueryCellInfoEventArgs) {
    // if (args.column!.headerText === "Employee Image") {
    //   if ((args as any).name === "excelQueryCellInfo") {
    //     args.image = {
    //       height: 75,
    //       base64: args.data["EmployeeImage"],
    //       width: 75,
    //     };
    //   } else {
    //     args.image = { base64: args.data["EmployeeImage"] };
    //   }
    // }
    // if (args.column!.headerText === "Email ID") {
    //   args.hyperLink = {
    //     target: "mailto:" + args.data["EmailID"],
    //     displayText: args.data["EmailID"],
    //   };
    // }
  }

  function load() {
    // to do
  }

  function columnDragStart(args: any) {
    if (args.column.field === "referenceNo") {
      alertDialogInstance.current?.show();
    }
  }
  function created() {
    gridInstance.current?.on("columnDragStart", columnDragStart);
  }

  function toolbarClick(args: ClickEventArgs): void {
    if (args.item.id?.endsWith("_excelexport")) {
      console.log("args.item.id");
      console.log(args.item.id);
      if (gridInstance.current) {
        gridInstance.current.excelExport();
      }
    }
  }

  let modifiedWcsData = wcsData.map((item) => {
    return {
      ...item,
      workContractDate: item.workContractDate
        ? new Date(item.workContractDate)
        : null,
      clientPODate: item.clientPODate ? new Date(item.clientPODate) : null,
      completionDate: item.completionDate
        ? new Date(item.completionDate)
        : null,
      closedDateTime: item.closedDateTime
        ? new Date(item.closedDateTime)
        : null,
    };
  });

  function amountSum(props: any) {
    return <span>Sum: {props.Sum.toFixed(2)}</span>;
  }

  return (
    <ErrorBoundary>
      <div className="w-full pb-12 min-h-screen">
        <div className="control-pane mx-auto py-3">
          <div className="control-section">
            <GridComponent
              className="mx-auto dark:bg-slate-950"
              dataSource={modifiedWcsData}
              allowPaging={true}
              allowExcelExport={true}
              ref={gridInstance}
              toolbar={toolbarOptions}
              toolbarClick={(e) => toolbarClick(e)}
              pageSettings={{ pageCount: 5, pageSize: 15 }}
              allowFiltering={true}
              enableAltRow={true}
              filterSettings={filterSettings}
              editSettings={editSettings}
              allowGrouping={true}
              groupSettings={groupOptions}
              allowSorting={true}
              rowHeight={25}
              height="auto"
              dataBound={() => dataBound()}
              excelQueryCellInfo={(e) => exportQueryCellInfo(e)}
              load={load}
              created={created}
              allowReordering={true}
              allowResizing={true}
            >
              <ColumnsDirective>
                <ColumnDirective
                  allowGrouping={false}
                  field="clientPO"
                  headerText="PO No."
                  width="130"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="clientPODate"
                  headerText="PO Date"
                  width="150"
                  textAlign="Left"
                  format={dateFormat}
                />
                <ColumnDirective
                  field="itemName"
                  headerText="Item Name"
                  width="220"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="shade"
                  headerText="Shade"
                  width="120"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="netQuantity"
                  headerText="PO Quantity"
                  width="150"
                  textAlign="Right"
                />
                <ColumnDirective
                  field="dispatchedBilling"
                  headerText="Dispached Billing"
                  width="150"
                  textAlign="Right"
                />
                <ColumnDirective
                  field="balance"
                  headerText="Balance"
                  width="150"
                  textAlign="Right"
                />
                <ColumnDirective
                  field="workContractDate"
                  headerText="PO Received date"
                  width="150"
                  format={dateFormat}
                  textAlign="Left"
                />
                <ColumnDirective
                  field="completionDate"
                  headerText="Completion Date"
                  width="150"
                  format={dateFormat}
                  textAlign="Left"
                />
                <ColumnDirective
                  field="fabricReceiptDate"
                  headerText="Fabric Receipt Date"
                  width="150"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="machineLoadingDate"
                  headerText="Machine Loading Date"
                  width="150"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="machineUnloadingDate"
                  headerText="Machine Unloading Date"
                  width="150"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="finishingDate"
                  headerText="Finishing Date"
                  width="150"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="fobSentDate"
                  headerText="FOB Sent Date"
                  width="150"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="fobApprovalDate"
                  headerText="FOB Approval Date"
                  width="150"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="packingDate"
                  headerText="Packing Date"
                  width="150"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="dispatchedDate"
                  headerText="Dispatched Date"
                  width="150"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="closedDateTime"
                  headerText="Closed Date"
                  width="150"
                  format={dateFormat}
                  textAlign="Left"
                />
                <ColumnDirective
                  field="rpInwardDate"
                  headerText="RP Inward Date"
                  width="150"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="rpOutwardDate"
                  headerText="RP Outward Date"
                  width="150"
                  textAlign="Left"
                />
              </ColumnsDirective>
              <AggregatesDirective>
                <AggregateDirective>
                  <AggregateColumnsDirective>
                    <AggregateColumnDirective
                      field="netQuantity"
                      type="Sum"
                      groupFooterTemplate={amountSum}
                      footerTemplate={amountSum}
                    />
                    <AggregateColumnDirective
                      field="dispatchedBilling"
                      type="Sum"
                      groupFooterTemplate={amountSum}
                      footerTemplate={amountSum}
                    />
                    <AggregateColumnDirective
                      field="balance"
                      type="Sum"
                      groupFooterTemplate={amountSum}
                      footerTemplate={amountSum}
                    />
                  </AggregateColumnsDirective>
                </AggregateDirective>
              </AggregatesDirective>
              <Inject
                services={[
                  Page,
                  Toolbar,
                  ExcelExport,
                  Aggregate,
                  Group,
                  Sort,
                  Edit,
                  Filter,
                  Reorder,
                  Resize,
                ]}
              />
            </GridComponent>
            <DialogComponent
              id="alertDialog"
              header="Grouping"
              visible={visible}
              animationSettings={animationSettings}
              width="300px"
              content="Grouping is disabled for this column"
              ref={alertDialogInstance}
              target=".control-section"
              buttons={alertButtons}
            />
          </div>
        </div>
      </div>
    </ErrorBoundary>
  );
}

export default WcsComponent;
